// ** React Imports
import { useState, useEffect } from "react";
import axios from "axios";
import { Controller, useForm } from "react-hook-form";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import fileDownload from "js-file-download";
// import Box from '@mui/material/Box'
// import Container from '@mui/material/Container'
import {
  Modal,
  Box,
  Button,
  Container,
  Stack,
  SvgIcon,
  Typography,
  Grid,
  Snackbar,
  TextField,
  Tooltip,
  Chip,
} from "@mui/material";
import React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
// import Button from '@mui/material/Button'
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import Paper from "@mui/material/Paper";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

// import { Grid, Typography } from '@mui/material'
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { Backdrop } from "@mui/material";
import "../Button.css";
import Select from "react-select";
import Moment from "moment";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import ClaimRegistration from "../ClaimRegistration";
import Checkbox from "@mui/material/Checkbox";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Dialog from "@mui/material/Dialog";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ReactSelect from "react-select";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";

import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import Headroom from "react-headroom";
import DialogTitle from "@mui/material/DialogTitle";
import { useAlert } from "react-alert";
import PatientRegistration from "../PatientRegistration";
import Swal from "sweetalert2";
import { CloseOutlined } from "@mui/icons-material";
import { useSelector } from "react-redux";

const Claim = (props) => {
  document.title = "Claim | LuxBilling";
  const rights = useSelector((state) => state.login.rights);

  const [patientId, setpatientId] = useState(
    props.PatientId !== undefined ? props.PatientId : 0
  );
  // const patientId = props.PatientId;
  const PatientName = props.PatientName; // comes From patient Registration
  const [patientName, setPatientName] = React.useState("");

  const [columnID, setColumnID] = React.useState("");
  const [columnIDpayment, setColumnIDpayment] = React.useState("");
  const [PatientNamepayemnt, setPatientNamepayemnt] = React.useState("");

  const [writepayemnt, setwritepayemnt] = React.useState("");
  const [djustmentpayemnt, setadjustmentpayemnt] = React.useState("");
  const [paidpayemnt, setpaidpayemnt] = React.useState("");
  const [allowpayemnt, setallowpayemnt] = React.useState("");
  const [balance, setbalance] = React.useState("");

  const [colpatientID, setcolpatientID] = React.useState("");
  const [isChecked, setIsChecked] = useState(true);
  const handleClick = () => {
    setIsChecked((prev) => {
      const newValue = !prev;
      console.log("Test", newValue);
      return newValue;
    });
  };
  const [openModalpayment, setOpenModalpayment] = React.useState(false);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [CompletdClaims, setCompletdClaims] = useState(null);

  const handleCloseModalpayment = () => {
    setPaymentDetails(null);
    setColumnIDpayment(0);
    setOpenModalpayment(false);
    setCompletdClaims(null);
  };

  const handleOpenpayment = () => {
    reset();
    setOpenModalpayment(true);
    setColumnID(0);
    // setSelectedPatient("")
  };
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    // applyRefresh()
    setOpenModal(false);
    setclaimPracticeID("");
  };

  const [isDialogOpen, setDialogOpen] = useState(false);
  const [Delbyid, setDelbyid] = useState(false);

  const handleDelete = (cell) => {
    // Perform your delete logic here
    const postData = {
      id: Delbyid,
      inactive: true,
    };

    axios
      .post(`${process.env.REACT_APP_API_URL}/claims/addclaims`, postData, {
        headers,
      })
      .then((response) => {
        setRefresh(!refresh);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
    // Close the dialog
    setDialogOpen(false);
  };

  const handleOpen1 = (value) => {
    reset();
    setOpenModal(true);
    setColumnID(0);
    setPatientName("");
    setcolpatientID("");

    // if(testpateint == '' && patientName != '')
    // {
    //   setPatientName('')
    // }
    // else{
    //   setPatientName(testpateint)
    // }
  };
  const [groupName, setGroupName] = React.useState(false);
  const handleOpengroupName = () => setGroupName(true);
  const handleClosegroupName = () => {
    setGroupName(false);
    setcheckamount("");
    setcheckdate("");
    setpayer("");
    setcheckno("");
    setcheckdateError('')
    setPayerError('')
    setchecknoError('')
    setCheckAmountError('')
  };
  const [Makepayment, setMakepayment] = React.useState(false);
  const [followUpdate, setfollowUpdate] = useState("");

  const handleopenMakepayment = () => setMakepayment(true);
  const [errorsState, setErrorsState] = useState({
    patientName: "",
    checkamount: "",
    checkdate: "",
     source: "",
  dos: "",
  code: "",
  });
  const [comments, setcomments] = useState("");
  const handlecloseMakepayment = () => {
    setMakepayment(false);
    setsource("");
    setcheckno("");
    setcheckamount("");
    setcode("");
    setcheckdate("");
    setPatientID("");
    setPatientNamee1("");
    setcomments("");
    setValue("patientName", "");
    setErrorsState({
      patientName: "",
      checkamount: "",
      checkdate: "",
        source: "",
  dos: "",
  code: "",
    });
    // Reset source when closing
  };
  const [claimPracticeID, setclaimPracticeID] = React.useState("");
  const [ClaimStatus, setClaimStatus] = useState([]);
  const statusOptions = [
    { value: "all", label: "All" },
    { value: "new", label: "🔴New" },
    { value: "pending", label: "🟠Pending" },
    { value: "pendingFurtherProcess", label: "🟣Pending further Review" },
    { value: "secondaryPending", label: "🟤Secondary Pending" },
    {
      value: "secondaryPendingReviews",
      label: "🟪Secondary Pending further Review",
    },
    { value: "completed", label: "🟢Completed" },
    { value: "pendingInsuranceCheck", label: "🎀Pending Insurance Check..." },
    { value: "paidToPatient", label: "💲Paid To Patient" },
    { value: "paid", label: "🔵Paid" },
    { value: "partiallyPaid", label: "💠Partially Paid" },
    { value: "closed", label: "⚫Closed" },
  ];
const handleStatusChange = (selectedOptions) => {
  const values = selectedOptions
    ? selectedOptions.map(option => option.value)
    : [];

  setClaimStatus(values);
};

  const UserType = localStorage.getItem("User_Type");
  const [selectedIds, setSelectedIds] = useState([]);
  const handleCheckboxClick = (rowId) => {
    setSelectedIds(
      (prev) =>
        prev.includes(rowId)
          ? prev.filter((id) => id !== rowId) // uncheck → remove
          : [...prev, rowId] // check → add
    );
  };
  const [ediFilePath, setEdiFilePath] = useState(""); // ✅ store ediFilePath
  const handleGenerateClaims = async () => {
    if (!selectedIds || selectedIds.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Claims Selected",
        text: "Please select at least one claim before generating a batch.",
        didRender: () => {
          const el = document.querySelector(".swal2-container");
          if (el) el.style.zIndex = 1800;
        },
      });
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Batches/generateBatchFromClaimIds`,
        selectedIds,
        { headers }
      );

      const data = response;
      setEdiFilePath(data.ediFilePath || "");
      setLoading(false);
      await Swal.fire({
        icon: data.success ? "success" : "error",
        title: data.success
          ? "Batch Generated Successfully!"
          : "Batch Generation Failed",
        width: "520px",
        padding: "1.5rem",
        background: "#f9fafb",
        color: "#111",
        html: `
        <div style="text-align: left; font-size: 15px; line-height: 1.6; margin-top: 10px;">
          <div style="background: #ffffff; padding: 12px 15px; border-radius: 10px; border: 1px solid #e5e7eb;">
            <p><b style="color:#374151;">Message:</b> ${data.message}</p>
            <p><b style="color:#374151;">Batch ID:</b> ${
              data.batchId || "N/A"
            }</p>
            <p><b style="color:#374151;">Total Claims:</b> ${
              data.totalClaims || "0"
            }</p>
          </div>

          ${
            data.success
              ? `
              <div style="margin-top: 20px; display:flex; justify-content:center; gap:12px;">
                <button id="downloadBtn"
                  style="
                    background: #2563eb;
                    color: white;
                    border: none;
                    padding: 10px 18px;
                    border-radius: 8px;
                    cursor: pointer;
                    font-size: 14px;
                    font-weight: 600;
                  "
                >
                  📥 Download EDI
                </button>

                <button id="uploadBtn"
                  style="
                    background: #059669;
                    color: white;
                    border: none;
                    padding: 10px 18px;
                    border-radius: 8px;
                    cursor: pointer;
                    font-size: 14px;
                    font-weight: 600;
                  "
                >
                  ☁ Upload to Clearing House
                </button>
              </div>
            `
              : ""
          }
        </div>
      `,
        showConfirmButton: false,
        didRender: () => {
          // 💥 Z-INDEX FIX HERE
          const el = document.querySelector(".swal2-container");
          if (el) el.style.zIndex = 1800;

          const downloadBtn = document.getElementById("downloadBtn");
          if (downloadBtn) {
            downloadBtn.addEventListener("click", async () => {
              await handleDownloadEdiFile(data.ediFilePath);
            });
          }

          const uploadBtn = document.getElementById("uploadBtn");
          if (uploadBtn) {
            uploadBtn.addEventListener("click", async () => {
              uploadClaims(data.ediFilePath);
            });
          }
        },
      });
    } catch (error) {
      console.error("There was an error!", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while generating the batch. Please try again.",
        didRender: () => {
          const el = document.querySelector(".swal2-container");
          if (el) el.style.zIndex = 1800;
        },
      });
    } finally {
      setLoading(false);
    }
  };

const uploadClaims = async (filePath) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/Batches/uploadBatchFile?batchURL=${filePath}`,
      {},
      { headers, responseType: "text" }
    );

    const xmlString = response;
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, "text/xml");

    const claimNode = xmlDoc.querySelector("result > claim");

    // ---------------- SUCCESS CASE (ACK) ----------------
    const ackNode = claimNode?.querySelector('messages[mesgid="ACK"]');

    if (ackNode) {
      Swal.fire({
        icon: "success",
        title: "Upload Successful",
        html: `
          <b>Claims uploaded successfully!</b><br/><br/>
          ClaimMD Response: <span style="color:green">ACK - Acknowledged</span>
        `,
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
        didRender: () => {
          const el = document.querySelector(".swal2-container");
          if (el) el.style.zIndex = 1800;
        },
      });
      return;
    }

    // ---------------- VALIDATION ERRORS (UL Compact View) ----------------
    const messageNodes = claimNode?.querySelectorAll("messages");

    if (messageNodes && messageNodes.length > 0) {
      let errorHtml = `
        <div style="text-align:left; max-height:300px; overflow-y:auto;">
          <b>ClaimMD Validation Failed</b><br/><br/>
          <ul style="padding-left:18px; margin:0;">
      `;

      messageNodes.forEach((node) => {
        const mesgid = node.getAttribute("mesgid");
        const message = node.getAttribute("message");
        const field = node.getAttribute("fields");

        errorHtml += `
          <li style="margin-bottom:6px;">
            <span style="color:red;">${message || "Validation error"}</span>
            <br/>
            <small>Field: ${field || "-"} | Code: ${mesgid || "-"}</small>
          </li>
        `;
      });

      errorHtml += `
          </ul>
        </div>
      `;

      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        html: errorHtml,
        width: 600,
        didRender: () => {
          const el = document.querySelector(".swal2-container");
          if (el) el.style.zIndex = 1800;
        },
      });

      setLoading(false);
      return;
    }

    // ---------------- ERROR NODE <error> ----------------
    const errorNode = xmlDoc.querySelector("result > error");

    if (errorNode) {
      const errorMesg =
        errorNode.getAttribute("error_mesg") || "Unknown error";

      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        html: `
          <div style="text-align:left;">
            <b>ClaimMD Error:</b><br/><br/>
            ${errorMesg}
          </div>
        `,
        didRender: () => {
          const el = document.querySelector(".swal2-container");
          if (el) el.style.zIndex = 1800;
        },
      });

      setLoading(false);
      return;
    }

    // ---------------- UNKNOWN RESPONSE ----------------
    Swal.fire({
      icon: "warning",
      title: "Unexpected Response",
      html: `
        ClaimMD returned an unrecognized format.<br/><br/>
        <div style="max-height:250px; overflow:auto; text-align:left;">
          <pre style="background:#f3f4f6;padding:10px;border-radius:5px;">
${xmlString}
          </pre>
        </div>
      `,
      width: 650,
      didRender: () => {
        const el = document.querySelector(".swal2-container");
        if (el) el.style.zIndex = 1800;
      },
    });

    setLoading(false);
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Upload Error",
      text: "Upload failed: " + error.message,
      didRender: () => {
        const el = document.querySelector(".swal2-container");
        if (el) el.style.zIndex = 1800;
      },
    });

    setLoading(false);
  }
};

  const handleDownloadEdiFile = async (filePath) => {
    try {
      const encodedPath = encodeURIComponent(filePath);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/PatientDocument/DownloadAWSFile?path=${encodedPath}`,
        {
          headers,
          responseType: "blob",
        }
      );

      const filename = filePath.split("/").pop() || `Batch_${Date.now()}.txt`;
      fileDownload(response, filename);

      Swal.fire({
        icon: "success",
        title: "Download Complete",
        text: `EDI file "${filename}" downloaded successfully!`,
             timer: 3000, 
          timerProgressBar: true,
          showConfirmButton: false,
        didRender: () => {
          const el = document.querySelector(".swal2-container");
          if (el) el.style.zIndex = 1800;
        },
      });
    } catch (error) {
      console.error("Error downloading EDI file:", error);
      Swal.fire({
        icon: "error",
        title: "Download Failed",
        text: "Could not download the EDI file.",
        didRender: () => {
          const el = document.querySelector(".swal2-container");
          if (el) el.style.zIndex = 1800;
        },
      });
    }
  };
  const handleGenerateSuperBill = async () => {
    if (!selectedIds || selectedIds.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Claims Selected",
        text: "Please select at least one claim before generating a Bill.",
        didRender: () => {
          const el = document.querySelector(".swal2-container");
          if (el) el.style.zIndex = 1800;
        },
      });
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/claims/GenerateClaimPdf`,
        selectedIds,
        {
          headers,
          responseType: "blob", // important for downloading files
        }
      );

      // Convert blob to a downloadable link
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "SuperBill.pdf"); // download filename
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      setSelectedIds([]);
      // ✅ SweetAlert success notification
      Swal.fire({
        icon: "success",
        title: "Super Bill Generated!",
        text: "The PDF has been successfully generated and downloaded.",
               showConfirmButton: false,   
  timer: 1500,                
  timerProgressBar: true,
        timer: 4000,
        didRender: () => {
          const el = document.querySelector(".swal2-container");
          if (el) el.style.zIndex = 1800;
        },
      });
    } catch (error) {
      console.error("There was an error!", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while generating the Bill. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      field: "Select",
      headerName: "Select",
      flex: 0.4,
      sortable: false,
      headerClassName: "super-app-theme--header",
      renderCell: (cellValues) => (
        <Checkbox
          checked={selectedIds.includes(cellValues.row.id)}
          onClick={() => handleCheckboxClick(cellValues.row.id)}
          color="primary"
        />
      ),
    },
    {
      field: "id",
      headerName: "ID",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.2,
      minWidth: 50,
    },
    // {
    //   field: "viewDetails",
    //   headerName: "View Details",
    //   cellClassName: "gridCell",
    //   sortable: true,
    //   headerClassName: "super-app-theme--header",
    //   flex: 0.3,
    //   minWidth: 170,
    //   renderCell: (cellValues) => (
    //     <Button
    //       style={{ display: "flex", justifyContent: "flex-start" }}
    //       size="small"
    //       variant="text"
    //       color="info"
    //       onClick={(event) => {
    //         setColumnID(cellValues.row.id);
    //         setcolpatientID(cellValues.row.patientId);
    //         setPatientName(cellValues.row.patientName);
    //         setclaimPracticeID(cellValues.row.practiceId);
    //         setOpenModal(true);
    //         // openClaimRegistration(event,cellValues.row.id )
    //       }}
    //     >
    //       View Details
    //     </Button>
    //   ),
    // },
    {
      field: "patientName",
      headerName: "Patient Name",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.3,
      minWidth: 170,
      renderCell: (cellValues) => (
        <Tooltip title="Click Here To View Cliam Details">
        <Button
          style={{ display: "flex", justifyContent: "flex-start" }}
          size="small"
          variant="text"
          color="info"
          onClick={(event) => {
            setColumnID(cellValues.row.id);
            setcolpatientID(cellValues.row.patientId);
            setPatientName(cellValues.row.patientName);
            setclaimPracticeID(cellValues.row.practiceId);
            setOpenModal(true);
            // openClaimRegistration(event,cellValues.row.id )
          }}
        >{`${cellValues.row.patientName}`}</Button>
        </Tooltip>
      ),
    },
    {
      field: "dos",
      headerName: "DOS",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.26,
      minWidth: 110,
    },

    // {
    //   field: "status",
    //   headerName: "Status",
    //   flex: 0.2,
    //   minWidth: 180,
    //   sortable: true,
    //   renderCell: (params) => {
    //     const { payment, submitted, compeleted, New, CreatedDate, closeClaim } =
    //       params.row || {};
    //     const isNew = New === "true";
    //     let value = "";
    //     let bg = "";

    //     const twoWeeksAgo = new Date();
    //     twoWeeksAgo.setDate(twoWeeksAgo.getDate() - followUpdate);
    //      switch (true) {
    //       case closeClaim === true:
    //         value = "Closed";
    //         bg = "black";
    //         break;

    //       case !!payment:
    //         value = "Paid";
    //         bg = "#1976d2";
    //         break;

    //       case !compeleted && !payment && !New: {
    //         const createdDate = new Date(CreatedDate);
    //         if (
    //           CreatedDate &&
    //           !isNaN(createdDate) &&
    //           createdDate >= twoWeeksAgo
    //         ) {
    //           value = "Pending";
    //           bg = "#ff9800"; // orange
    //         } else {
    //           value = "Pending further Process";
    //           bg = "purple";
    //         }
    //         break;
    //       }

    //       case compeleted && !payment && !closeClaim:
    //         value = "Completed";
    //         bg = "green";
    //         break;

    //       case isNew:
    //         value = "New";
    //         bg = "red";
    //         break;

    //       default:
    //         value = "";
    //         bg = "";
    //         break;
    //     }

    //     return (
    //       <div
    //         style={{
    //           backgroundColor: bg,
    //           padding: "4px 8px",
    //           borderRadius: 4,
    //           width: "100%",
    //           color: "#fff",
    //           textAlign: "center",
    //         }}
    //       >
    //         {value}
    //       </div>
    //     );
    //   },
    //   filterable: true,
    //   type: "singleSelect",
    //   valueOptions: [
    //     "Paid",
    //     "Pending",
    //     "Pending further Process",
    //     "Completed",
    //     "New",
    //     "Closed",
    //   ],
    // },
    {
      field: "status",
      headerName: "Status",
      flex: 0.4,
      minWidth: 220,
      sortable: true,
      renderCell: (params) => {
        const { StatusColor } = params.row || {};
        let value = "";
        let bg = "";

        switch (StatusColor) {
          case "red":
            value = "New";
            bg = "red";
            break;
          case "brown":
            value = "Secondary Pending";
            bg = "brown";
            break;
          case "orange":
            value = "Pending";
            bg = "#ff9800"; // common color for both
            break;
          case "purple":
            value = "Pending further review";
            bg = "purple";
            break;
          case "Blueviolet":
            value = "Secondary Pending further review";
            bg = "Blueviolet";
            break;
          case "green":
            value = "Completed";
            bg = "green";
            break;
          case "black":
            value = "Closed";
            bg = "black";
            break;
          case "skyblue":
            value = "Partially Paid";
            bg = "skyblue";
            break;
          case "blue":
            value = "Paid";
            bg = "blue";
            break;
              case "lightgreen":
            value = "Paid to Patient";
            bg = "lightgreen";
            break;
             case "deepPink":
            value = "Pending insurance check...";
            bg = "deepPink";
            break;
          default:
            value = "Unknown";
            bg = "#9e9e9e"; // gray
            break;
        }

        return (
          <div
            style={{
              backgroundColor: bg,
              padding: "4px 6px",
              borderRadius: 4,
              width: "100%",
              color: "#fff",
              textAlign: "center",
            }}
          >
            {value}
          </div>
        );
      },
      filterable: true,
      type: "singleSelect",
      valueOptions: [
        "Paid",
        "Pending",
        "Pending further Process",
        "Completed",
        "New",
        "Closed",
      ],
    },

    {
      field: "attendingPhysicianName",
      headerName: "Rendering",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.23,
      minWidth: 150,
    },
    ...(rights?.Claim_Payment
      ? [
          {
            field: "payment",
            headerName: "Payment",
            cellClassName: "gridCell",
            sortable: true,
            headerClassName: "super-app-theme--header",
            flex: 2,
            minWidth: 150,
            renderCell: (cellValues) => (
              <Tooltip title="Make payment for this claim line only">
                <button
                  style={{
                    backgroundColor: cellValues.row.StatusColor,
                    color: "white",
                    color: "white",
                    border: "none",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    fontSize: "13px",
                    fontWeight: "bold",
                    // width: '100%',
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    setColumnIDpayment(cellValues.row.id);
                    setPatientNamepayemnt(cellValues.row.patientName);
                    setCompletdClaims(cellValues.row.compeleted);
                    handleOpenpayment();
                  }}
                >
                  Make Payment
                </button>
              </Tooltip>
            ),
          },
        ]
      : []),

    {
      field: "Carries",
      headerName: "Carriers",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.2,
      minWidth: 150,
    },
    {
      field: "CreatedDate",
      headerName: "Submitted Date",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.2,
      minWidth: 150,
      valueFormatter: (params) => {
        return params.value ? Moment(params.value).format("MM-DD-YYYY") : "";
      },
    },
    {
      field: "updateddate",
      headerName: "Last Work Date",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.2,
      minWidth: 150,
      valueFormatter: (params) => {
        return params.value ? Moment(params.value).format("MM-DD-YYYY") : "";
      },
    },
    {
      field: "totalCharges",
      headerName: "Charges",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.15,
      minWidth: 150,
    },
    {
      field: "amountAllowed",
      headerName: "Allowed",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.2,
      minWidth: 150,
    },
    {
      field: "cpt1",
      headerName: "Cpt 1",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.2,
      minWidth: 100,
    },
    {
      field: "cpt2",
      headerName: "Cpt 2",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.2,
      minWidth: 100,
    },
    {
      field: "cpt3",
      headerName: "Cpt 3",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.2,
      minWidth: 100,
    },
    {
      field: "amountPaid",
      headerName: "Paid",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.13,
      minWidth: 100,
    },
    {
      field: "adjustments",
      headerName: "Adj",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.12,
      minWidth: 100,
    },
    {
      field: "writeOff",
      headerName: "Write",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.1,
      minWidth: 100,
    },
    {
      field: "amountDue",
      headerName: "Balance",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.2,
      minWidth: 100,
    },

    {
      field: "practiceName",
      headerName: "Practice",
      cellClassName: "gridCell",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 0.3,
      minWidth: 120,
    },
    // {
    //   field: 'refferringPhysicianName',
    //   headerName: 'Refferring Name',
    //   cellClassName: 'gridCell',
    //   sortable: true,
    //   headerClassName: 'super-app-theme--header',
    //   flex: 0.3
    // },
    ...(rights?.Delete_Claim
      ? [
          {
            field: "delete",
            headerClassName: "super-app-theme--header",
            headerName: "Delete",
            flex: 0.2,
            minWidth: 80,
            align: "center",
            // headerAlign: 'center',
            renderCell: (cell) => (
              <>
                <DeleteIcon
                  style={{
                    marginRight: "5px",
                    float: "right",
                    marginTop: "5px",
                    color: "red",
                    cursor: "pointer",
                  }}
              onClick={() => {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#6c7c84",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        heightAuto: false,
        backdrop: true,
      }).then((result) => {
        if (result.isConfirmed) {
          const postData = {
            id: cell.row.id,
            inactive: true,
          };

          axios
            .post(
              `${process.env.REACT_APP_API_URL}/claims/addclaims`,
              postData,
              { headers }
            )
            .then(() => {
              setRefresh(!refresh);

              // ✅ Success auto-close alert
              Swal.fire({
                title: "Deleted!",
                text: "Record has been deleted.",
                icon: "success",
                showConfirmButton: false,
                timer: 1500,
                heightAuto: false,
              });
            })
            .catch((error) => {
              Swal.fire({
                title: "Error!",
                text: "Something went wrong.",
                icon: "error",
              });
              console.error(error);
            });
        }
      });
    }}
                ></DeleteIcon>
                {/* <Dialog
                  open={isDialogOpen}
                  onClose={() => setDialogOpen(false)}
                  aria-labelledby="delete-dialog-title"
                  BackdropComponent={Backdrop}
                  BackdropProps={{
                    invisible: true,
                  }}
                  PaperProps={{
                    style: {
                      // marginRight: '5px',
                      // float: 'right',
                      marginTop: "5px",
                      color: "red",
                      cursor: "pointer",
                    },
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center", // Center horizontally
                      justifyContent: "center", // Center vertically
                      borderRadius: "8px",
                      width: "500px",
                    }}
                  >
                    <ErrorOutlineIcon
                      style={{ fontSize: "100px", color: "red" }}
                    />
                    <DialogTitle
                      style={{
                        fontWeight: "bold",
                        color: "black",
                        fontSize: " 1.25rem",
                      }}
                    >
                      Are you sure?
                    </DialogTitle>
                    <h5
                      style={{
                        textAlign: "center",
                        fontSize: "16px",
                        fontWeight: "normal",
                        color: "#444444",
                      }}
                    >
                      You won't be able to revert this!
                    </h5>
                    <DialogContent>
                      <DialogContentText>
                        <Grid style={{ marginTop: "1rem" }}>
                          <Button
                            onClick={() => setDialogOpen(false)}
                            style={{
                              backgroundColor: "#6c7c84",
                              color: "white",
                              marginBottom: "1rem",
                            }}
                          >
                            No,cancel!
                          </Button>
                          <Button
                            onClick={() => handleDelete(cell)}
                            style={{
                              backgroundColor: "red",
                              color: "white",
                              marginLeft: "1rem",
                              marginBottom: "1rem",
                              border: "1px solid #b4acec",
                            }}
                          >
                            Yes,delete it!
                          </Button>
                        </Grid>
                      </DialogContentText>
                    </DialogContent>
                  </div>
                </Dialog> */}
              </>
            ),
          },
        ]
      : []),
  ];
  const getRowSpacing = React.useCallback((params) => {
    return {
      top: params.isFirstVisible ? 0 : 0.5,
      bottom: params.isLastVisible ? 0 : 0.8,
    };
  }, []);

  const [isLoading, setLoading] = useState(false);
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };
  const gridStyle = {
    color: "#8392ab !important",
    textTransform: "lowercase",
    fontSize: "13.6px",
    fontWeight: "400",
    "&:hover": {
      color: "rgba(5, 152, 236, 0.637) !important",
      fontSize: "14.6px",
    },
  };

  const gridRowStyle = {
    boxShadow: 2,
    border: 2,
    borderRadius: 2,
    background: "white", // Use white or another valid color
    fontSize: "12px",
    color: "black",
    borderColor: "#326C1D",
    whiteSpace: "nowrap",

    "& .MuiDataGrid-root": {
      overflowX: "auto", // Enable horizontal scrolling
    },

    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: "#377562",
      color: "white",
      fontSize: "14px",
      fontWeight: "bold",
      textAlign: "center",
    },

    "& .MuiDataGrid-cell": {
      fontSize: "12px",
      textAlign: "left",
      overflow: "hidden",
      textOverflow: "ellipsis", // Prevents text overflow
      whiteSpace: "nowrap",
    },

    "& .MuiDataGrid-cell:hover": {
      color: "rgba(5, 152, 236, 0.637)",
    },
  };

  const style1 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1000,
    height: 500,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    overflow: "auto",
    // overflows: "hide",
    // zIndex: "10",
    customHeader: {
      backgroundColor: "black", // Apply your desired background color
      color: "white", // Apply the desired text color
      fontWeight: "bold",
    },
  };

  const [allowamount, setallowamount] = useState(0);
  const [paidamount, setpaidamount] = useState(0);
  const [adjustmentamount, setadjustmentamount] = useState(0);
  const [writeoff, setwriteoff] = useState(0);

  const [checkno, setcheckno] = useState("");
  const [source, setsource] = useState("");

  const [payer, setpayer] = useState("");
  const [checkamount, setcheckamount] = useState("");
  const [checkdate, setcheckdate] = React.useState("");
  const [refreshpayment, setRefreshpayment] = useState(false);
  function applyRefreshpayment() {
    setRefreshpayment(!refreshpayment);
  }
  const [payerError, setPayerError] = useState("");
  const [checkAmountError, setCheckAmountError] = useState("");
  const [checknoError, setchecknoError] = useState("");
  const [checkdateError, setcheckdateError] = useState("");
  const [Payers, setPayers] = useState([]);
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/Insurances/getInsurance`, {
        headers,
      })
      .then((response) => {
        var prov = [];
        response.forEach((field) => {
          prov.push({
            label: field.name,
            value: field.name,
          });
        });
        setPayers(prov);
      })
      .catch((error) => {});
  }, []);
  const AddGroup = (event) => {
    setPayerError("");
    setCheckAmountError("");

    let isValid = true;

    if (!checkno || checkno.trim() === "") {
      setchecknoError("Please Add Check # ");
      isValid = false;
    }
    if (!checkdate || checkdate.trim() === "") {
      setcheckdateError("Please Select Date ");
      isValid = false;
    }
    if (!payer) {
      setPayerError("Payer is required ");
      isValid = false;
    }

    if (!checkamount || checkamount === "") {
      setCheckAmountError("Check Amount is required");
      isValid = false;
    }

    // agar validation fail ho jaye to API call na karo
    if (!isValid) return;
    const postData = {
      checkno: checkno,
      payer: payer,
      checkamount: checkamount,
      checkdate: checkdate,
      // base64: base64Data
    };
    axios
      .post(`${process.env.REACT_APP_API_URL}/claims/AddERA`, postData, {
        headers,
      })
      .then((response) => {
        const savedCheck = response;
        const updatedRows = [...paymentDetails];
        const checkRowIndex = updatedRows.findIndex(
          (row) => row.paymentType === "Check"
        );
        setSearchText(savedCheck.checkno);
        if (checkRowIndex !== -1) {
          updatedRows[checkRowIndex].eRAId = savedCheck.id;
          updatedRows[checkRowIndex].checkno = savedCheck.checkno;
          updatedRows[checkRowIndex].payer = savedCheck.payer;
          updatedRows[checkRowIndex].checkdate = savedCheck.checkdate
            ? Moment(savedCheck.checkdate).format("DD/MM/YYYY")
            : "";
          updatedRows[checkRowIndex].checkamount = savedCheck.checkamount;
        }
        setPaymentDetails(updatedRows);
        handleClosegroupName("");
        Swal.fire({
          title: "Success!",
          text: "Record saved successfully.",
          icon: "success",
        showConfirmButton: false,   
  timer: 1500,                
  timerProgressBar: true,
          heightAuto: false,
          backdrop: true,
          didOpen: () => {
            const swalPopup = document.querySelector(".swal2-popup");
            const swalContainer = document.querySelector(".swal2-container");
            const swalBackdrop = document.querySelector(".swal2-backdrop");

            if (swalPopup) swalPopup.style.zIndex = "2800";
            if (swalContainer) swalContainer.style.zIndex = "2800";
            if (swalBackdrop) swalBackdrop.style.zIndex = "2799";
          },
        }).then(() => {
          setGroupName(false);
          applyRefreshpayment();
        });
      })
      .catch((error) => {
        Swal.fire({
          title: "Error!",
          text: error.message || "Something went wrong.",
          icon: "error",
               showConfirmButton: false,   
  timer: 1500,                
  timerProgressBar: true,
          heightAuto: false,
          backdrop: true,
          didOpen: () => {
            const swalPopup = document.querySelector(".swal2-popup");
            const swalContainer = document.querySelector(".swal2-container");
            const swalBackdrop = document.querySelector(".swal2-backdrop");

            if (swalPopup) swalPopup.style.zIndex = "2800";
            if (swalContainer) swalContainer.style.zIndex = "2800";
            if (swalBackdrop) swalBackdrop.style.zIndex = "2799";
          },
        });
      });
  };

  const [calimdos, setcalimdos] = useState([]);
  const [calimid, setcalimid] = useState("");

  const [calimdosvalue, setcalimdosvalue] = useState("");
  console.log("calimdosvalue", calimdosvalue);
  const [calimprocedureCode, setcalimprocedureCode] = useState([]);
  const [code, setcode] = useState("");
  const [patientID, setPatientID] = React.useState("");
  console.log("patientID", patientID);
  const FormCall = props.FormCall;

  const AddGroupmakepayment = (event) => {
    console.log("data", event);
    const newErrors = {
      patientName: "",
      checkamount: "",
      checkdate: "",
       source: "",
  dos: "",
  code: "",

    };

    let hasError = false;

    if (!(patientId > 0) && !patientID) {
      newErrors.patientName = "Please Enter Patient Name";
      hasError = true;
    }

    if (!checkamount) {
      newErrors.checkamount = "Please Enter the Amount";
      hasError = true;
    }

    if (!checkdate) {
      newErrors.checkdate = "Please select the Date";
      hasError = true;
    }
if (!source) {
    newErrors.source = "Please select Payment Source";
    hasError = true;
  }

  // DOS validation
  if (!calimdosvalue) {
    newErrors.dos = "Please select Date of Service";
    hasError = true;
  }

  if (!code) {
    newErrors.code = "Please select CPT Code";
    hasError = true;
  }
    if (hasError) {
      setErrorsState(newErrors);
      return;
    }
    const postData = {
      source: source,
      checkno: checkno,
      checkamount: checkamount,
      checkdate: checkdate,
      dos: calimdosvalue,
      claimId: calimid,
      cpt: code,
      // patientId: patientID,
      patientId: patientId > 0 ? patientId : patientID,
      comments: comments,
    };

    axios
      .post(`${process.env.REACT_APP_API_URL}/claims/AddERA`, postData, {
        headers,
      })
      .then((response) => {
        //   alert.success("Record saved successfully.", {
        //     type: "success",
        //     onClose: () => {
        //       // setGroupName(false)
        //       handlecloseMakepayment()
        //       if (FormCall === "demographic") {
        //         // window.location.reload();
        //         props.setRefreshDemoGraphic(true)
        //       }
        //     },
        //     style: {
        //       zIndex: 1760,
        //       position: 'fixed',
        //       top: '20px',
        //       right: '20px',
        //       backgroundColor: '#4caf50',
        //       color: '#fff',
        //       padding: '10px 20px',
        //       borderRadius: '4px',
        //       boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
        //     }
        //   });
        // })
        Swal.fire({
          title: "Success!",
          text: "Record saved successfully.",
          icon: "success",
          timer: 3000, // Auto-close after 3 seconds
          timerProgressBar: true,
          showConfirmButton: false,
          heightAuto: false,
          backdrop: true,
          didOpen: () => {
            const popup = document.querySelector(".swal2-popup");
            const container = document.querySelector(".swal2-container");
            const backdrop = document.querySelector(".swal2-backdrop");

            if (popup) popup.style.zIndex = "2800";
            if (container) container.style.zIndex = "2800";
            if (backdrop) backdrop.style.zIndex = "2799";
          },
          willClose: () => {
            handlecloseMakepayment();
            if (FormCall === "demographic") {
              // window.location.reload();
              props.setRefreshDemoGraphic(true);
            }
          },
        });
      })
      .catch((error) => {
        // setSubmitting(false);
        // alert.error(`Error ${error.message}`, {
        //   type: "error"
        // });
      });
  };
  const [groupList, setGroupList] = useState([]);

  const [checkSearchResults, setcheckSearchResults] = React.useState(false);
  const [patientNamee, setPatientNamee] = useState("");
  const [checkNoData, setCheckNoData] = React.useState([]);
  const [searchText, setSearchText] = useState("");
const [checkSearchIndex, setcheckSearchIndex] = useState(null);
const [loadingIndex, setLoadingIndex] = useState(null);
const highlightMatch = (text, search) => {
  if (!search) return text;

  const regex = new RegExp(`(${search})`, "ig");
  const parts = text.split(regex);

  return parts.map((part, i) =>
    part.toLowerCase() === search.toLowerCase() ? (
      <span
        key={i}
        style={{
          color: "#1976d2",
          fontWeight: 700,
          backgroundColor: "#e3f2fd",
          padding: "2px 4px",
          borderRadius: 4,
        }}
      >
        {part}
      </span>
    ) : (
      part
    )
  );
};

const searchTimeout = React.useRef(null);
 const onChangeHandle = async (value, index) => {
  if (searchTimeout.current) {
    clearTimeout(searchTimeout.current);
  }

  if (!value.trim()) {
    setCheckNoData([]);
    setLoadingIndex(null);
    return;
  }

  searchTimeout.current = setTimeout(async () => {
    try {
      setLoadingIndex(index);

      const sendData = {
        id: 0,
        checkno: value,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/claims/SearchERA`,
        sendData,
        { headers }
      );

      setCheckNoData(response || []);
    } catch (error) {
      console.error("There was an error!", error);
      setCheckNoData([]);
    } finally {
      setLoadingIndex(null);
    }
  }, 400); // debounce
};

  const gridClasses = {
    columnHeader: "MuiDataGrid-columnHeaders",
  };
  const [value, setvalue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setvalue(newValue);
  };
  const alert = useAlert();
  const [refresh, setRefresh] = useState(false);
  const navigate = useNavigate();
  const [fromDate, setfromDate] = React.useState("");
  const [toDate, settoDate] = useState("");
  const [isAllPractics, setisAllPractics] = useState(false);

  function applyRefresh() {
    setRefresh(!refresh);
  }

  const {
    register,
    control,
    handleSubmit,
    setValue,
    reset,
    getValues,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    context: undefined,
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
    delayError: undefined,
    // resolver: yupResolver(validationSchema),
    // defaultValues: defValues
  });
  useEffect(() => {
    // Set the default value of fromDate to the 1st date of the current month
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const formattedFromDate = formatDate(firstDayOfMonth);
    setfromDate(formattedFromDate);

    // Set the default value of toDate to the current date
    const formattedToDate = formatDate(today);
    settoDate(formattedToDate);
  }, []); // Empty dependency array ensures this effect runs only once on mount
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const Namee = props.Namee;
  const [rows, setRows] = useState(null);
  useEffect(() => {
    if (isChecked) {
      onFilterSearch();
    }
  }, [isChecked, refresh, openModalpayment]);
  useEffect(() => {
    onFilterSearch();
  }, [refresh, openModalpayment, isAllPractics, ClaimStatus]);
  const onFilterSearch = (event) => {
    if (!isChecked && (!fromDate || !toDate)) {
      console.log(
        "No action needed: checkbox unchecked and no date range selected."
      );
      return; // Do nothing
    }

    setLoading(true);
    setRows(null);
    if (isChecked) {
      axios
        .get(
          `${
            process.env.REACT_APP_API_URL
          }/claims/ClaimsSummary?Isall=${true}&patientId=${patientId}&showAllPractices=${isAllPractics}&status=${ClaimStatus} `,
          { headers }
        )
        .then((response) => {
          // setRows(response)
          const data = response || [];

          let filteredData = response;
          const followUpDays =
            response.length > 0
              ? parseInt(response[0].followUpTime || "14")
              : 14;
          setfollowUpdate(followUpDays);
          const twoWeeksAgo = new Date();

          twoWeeksAgo.setDate(twoWeeksAgo.getDate() - followUpDays);
          // switch (ClaimStatus) {
          //   // case 'pending':
          //   //   filteredData = data.filter(
          //   //     item => item.compeleted === false && item.payment === false && !item.New
          //   //   );
          //   //   break;
          //   case "pending": {
          //     const res = data.filter(
          //       (f) => f.compeleted === false && f.payment === false && !f.New
          //     );
          //     filteredData = res.filter((item) => {
          //       const createdDate = new Date(item.CreatedDate);
          //       return (
          //         item.CreatedDate &&
          //         !isNaN(createdDate) &&
          //         createdDate >= twoWeeksAgo
          //       );
          //     });
          //     break;
          //   }
          //   case "pendingFurtherProcess": {
          //     const res = data.filter(
          //       (f) => f.compeleted === false && f.payment === false && !f.New
          //     );
          //     filteredData = res.filter((item) => {
          //       const createdDate = new Date(item.CreatedDate);
          //       return (
          //         !item.CreatedDate ||
          //         isNaN(createdDate) ||
          //         createdDate < twoWeeksAgo
          //       );
          //     });
          //     break;
          //   }

          //   case "paid":
          //     filteredData = data.filter((item) => item.payment === true);
          //     break;
          //   case "completed":
          //     filteredData = data.filter(
          //       (item) =>
          //         item.compeleted === true &&
          //         item.payment === false &&
          //         !item.closeClaim
          //     );
          //     break;
          //   case "new":
          //     filteredData = data.filter(
          //       (item) => item.New === "true" && !item.payment
          //     );
          //     break;
          //   case "closed":
          //     filteredData = data.filter((item) => item.closeClaim === true);
          //     break;
          //   case "all":
          //   default:
          //     filteredData = data;
          //     break;
          // }

          setRows(data);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    } else {
      console.log("false check", isChecked);
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/claims/ClaimsSummary?dateFrom=${fromDate}&dateTo=${toDate}&patientId=${patientId}&showAllPractices=${isAllPractics} `,
          { headers }
        )
        .then((response) => {
          const data = response || [];
          let filteredData = response;

          if (ClaimStatus === "secondaryPending") {
            filteredData = data.filter(
              (item) => item.secondaryPending === true
            );
          }

          const followUpDays =
            response.length > 0
              ? parseInt(response[0].followUpTime || "14")
              : 14;
          const twoWeeksAgo = new Date();

          twoWeeksAgo.setDate(twoWeeksAgo.getDate() - followUpDays);
          // switch (ClaimStatus) {
          //   case "pending": {
          //     const res = data.filter(
          //       (f) => f.compeleted === false && f.payment === false && !f.New
          //     );
          //     filteredData = res.filter((item) => {
          //       const createdDate = new Date(item.CreatedDate);
          //       return (
          //         item.CreatedDate &&
          //         !isNaN(createdDate) &&
          //         createdDate >= twoWeeksAgo
          //       );
          //     });
          //     break;
          //   }
          //   case "pendingFurtherProcess": {
          //     const res = data.filter(
          //       (f) => f.compeleted === false && f.payment === false && !f.New
          //     );
          //     filteredData = res.filter((item) => {
          //       const createdDate = new Date(item.CreatedDate);
          //       return (
          //         !item.CreatedDate ||
          //         isNaN(createdDate) ||
          //         createdDate < twoWeeksAgo
          //       );
          //     });
          //     break;
          //   }
          //   case "paid":
          //     filteredData = data.filter((item) => item.payment === true);
          //     break;
          //   case "completed":
          //     filteredData = data.filter(
          //       (item) => item.compeleted === true && item.payment === false
          //     );
          //     break;
          //   case "new":
          //     filteredData = data.filter(
          //       (item) => item.New === "true" && !item.payment
          //     );
          //     break;
          //   case "closed":
          //     filteredData = data.filter((item) => item.closeClaim === true);
          //     break;
          //   case "all":
          //   default:
          //     filteredData = data;
          //     break;
          // }
          setRows(data);
          setLoading(false);
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    }
  };
  // const onFilterSearch = event => {
  //   setLoading(true)

  //     axios.get(`${process.env.REACT_APP_API_URL}/claims/ClaimsSummary?dateFrom=${fromDate}&dateTo=${toDate}&patientId=${patientId}`, { headers })
  //       .then(response => {
  //         setLoading(false)
  //         setRows(response)

  //       })
  //       .catch(error => {
  //         console.error('Error fetching data:', error);
  //         setLoading(false)

  //       });

  // }
  const [errorArray, setErrorArray] = useState([]);

  // console.log('PaymentMethod',paymentDetails)
  useEffect(() => {
    setSearchText("");
    if (columnIDpayment > 0) {
      let isComponentMounted = true;
      const fetchData = async () =>
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/claims/PaymentById?claimId=${columnIDpayment}`,
            {
              headers,
            }
          )
          .then((response) => {
            if (response) {
              setPaymentDetails(response);
            }
          })
          .catch((error) => {
            console.error("There was an error!", error);
          });
      fetchData();
      return () => {
        isComponentMounted = false;
      };
    }
  }, [columnIDpayment]);
  const [claimData, setClaimData] = useState(null);

  // useEffect(() => {
  //   if (columnIDpayment > 0) {
  //     let isComponentMounted = true;
  //     const fetchData = async () =>
  //       axios
  //         .get(
  //           `${process.env.REACT_APP_API_URL}/claims/ClaimsById?claimId=${columnIDpayment}`,
  //           {
  //             headers,
  //           }
  //         )
  //         .then((response) => {
  //           if (response) {
  //             setClaimData(response);
  //           }
  //         })
  //         .catch((error) => {
  //           console.error("There was an error!", error);
  //         });
  //     fetchData();
  //     return () => {
  //       isComponentMounted = false;
  //     };
  //   }
  // }, [columnIDpayment]);
  const onSubmitClaimComplete = async (data) => {
    try {
      const claimRes = await axios.get(
        `${process.env.REACT_APP_API_URL}/claims/ClaimsById?claimId=${columnIDpayment}`,
        { headers }
      );
      const postData = {
        ...claimRes,
      };
      postData.compeleted = true;
      postData.payment = false;
      postData.closeClaim = true;

      await axios.post(
        `${process.env.REACT_APP_API_URL}/claims/addclaims`,
        postData,
        { headers }
      );

      setColumnIDpayment(0);
      setOpenModalpayment(false);
      setRefresh(true);
       Swal.fire({
      title: "Success!",
      text: "Record saved successfully.",
      icon: "success",
      showConfirmButton: false,   
      timer: 1500,                
      timerProgressBar: true,
      heightAuto: false,
      backdrop: true,
    }).then(() => {
      setOpenModalpayment(false);
    });
    } catch (error) {
      console.log("Error", error);
    }
  };
  const paymentSourseOption = [
    { label: "Patient", value: "Patient" },
    { label: "Carrier", value: "Carrier" },
  ];
  const paymentType = [
    { label: "Cash", value: "Cash" },
    { label: "Check", value: "Check" },
    { label: "Write off", value: "Write off" },
  ];
  const saveData = (data) => {
    console.log("testttttt");
    var postData = paymentDetails;

    axios
      .post(`${process.env.REACT_APP_API_URL}/claims/addpayment`, postData, {
        headers,
      })
      .then((response) => {
        // alert('Saved Successfully !')
        setColumnIDpayment(0);
        setOpenModalpayment(false);
        setRefresh(true);
        // alert.success("Record saved successfully.", {
        //   type: "success",
        //   onClose: () => {
        //     setOpenModalpayment(false);
        //     if (FormCall === "demographic") {
        //       // window.location.reload();
        //       props.setRefreshDemoGraphic(true);
        //     }
        //   },
        // });
           Swal.fire({
        title: "Success!",
        text: "Record saved successfully.",
        icon: "success",
        showConfirmButton: false,   // ❌ OK button hide
        timer: 1500,                // ⏱️ auto close
        timerProgressBar: true,
        heightAuto: false,
        backdrop: true,
      }).then(() => {
        // ✅ same onClose logic
        setOpenModalpayment(false);
        if (FormCall === "demographic") {
          props.setRefreshDemoGraphic(true);
        }
      });
      })
      .catch((error) => {
      });
  };
  const openClaimRegistration = (event, id = 0) => {
    navigate("/ClaimRegistration", { state: { Claimid: id } });
  };
  const modalstyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "white",
    border: "2px solid #356F60",
    boxShadow: 24,
    overflow: "hidden",
    // p: 4,
    borderRadius: "8px",
    overflow: "auto",
  };

  const patientListStyle = {
    cursor: "pointer",
    hover: {
      background: "#3b3b3b !important",
      color: "rgba(5, 152, 236, 0.637) !important",
    },
    color: "green",
    selection: {
      background: "#D7624E",
      color: "white",
    },
  };
  const [filename, setfilename] = useState([]);
  const [base64Data, setBase64Data] = useState([]);
  const [docError, setdocError] = useState(false);
  const [patient, setPatient] = React.useState(false);

  const [patientData, setPatientData] = React.useState([]);
  const [isLoading1, setIsLoading1] = useState(false);
  const [patientNamee1, setPatientNamee1] = useState("");
  const [Client, setClient] = useState("");

  const [searchText1, setSearchText1] = useState("");
  const onPatientHandle = async (value) => {
    console.log(value);
    setIsLoading1(true);

    const sendData = {
      id: 0,
      lastName: value,
      firstName: "",
      ssn: "",
      status: "",
      cellPhone: "",
      address: "",
      dob: "",
    };
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/Patients/searchPatient`,
        sendData,
        { headers }
      )

      .then((response) => {
        setPatientData(response);
        setPatient(true);
        setIsLoading1(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsLoading1(false);
      });
  };

  useEffect(() => {
    const id = patientId > 0 ? patientId : patientID;

    if (!id || id <= 0) return; //
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/claims/GetClaimDos?patientId=${
          patientId > 0 ? patientId : patientID
        }`,
        { headers }
      )
      .then((response) => {
        var rprov = [];

        response.forEach((field) => {
          rprov.push({
            label: `${field.dos}`,
            value: field.id,
            calimdos1: field.dos,
          });
        });
        setcalimdos(rprov);
      })
      .catch((error) => {});
  }, [patientID, patientId]);
  useEffect(() => {
    // POST request using axios inside useEffect React hook
    axios
      .get(`${process.env.REACT_APP_API_URL}/Procedures/Procedures`, {
        headers,
      })
      .then((response) => {
        var prac = [];
        response.forEach((field) => {
          prac.push({
            label: field.code,
            value: field.code,
            qasim: field.default_charges,
          });
        });
        setcalimprocedureCode(prac);
      })
      .catch((error) => {});
  }, []);
  const [diagnosisList, setDiagnosisList] = useState([]);
  useEffect(() => {
    if (openModalpayment === true) {
      axios
        .get(`${process.env.REACT_APP_API_URL}/Diagnosis/Diagnosis`, {
          headers,
        })
        .then((response) => {
          var prac = [];
          response.forEach((field) => {
            prac.push({
              label: field.code,
              value: field.id,
            });
          });
          setDiagnosisList(prac);
        })
        .catch((error) => {});
    }
  }, [openModalpayment]);
  const [openpatientreg, setOpenpatientreg] = React.useState(false);
  const handleOpenpatientreg = () => setOpenpatientreg(true);
  const handleClosepatientreg = () => setOpenpatientreg(false);
  const styleDetailspatient = {
    width: "90%",
    // height: '70%',
    height: 600,
    bgcolor: "white",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    margin: "auto",
    marginTop: "10px",
    paddingBottom: "10px",
    padding: "20px",
    overflow: "auto",
    scrollbarWidth: "thin", // For Firefox
    scrollbarColor: "#356F60 transparent", // thumb color and track color
    "&::-webkit-scrollbar": {
      width: 8 /* Width of vertical scrollbar */,
      height: 8 /* Height of horizontal scrollbar */,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#356F60" /* Color of the thumb */,
      borderRadius: 10,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent" /* Color of the track */,
    },
    /* Adjust the width for the horizontal scrollbar */
    "&::-webkit-scrollbar-thumb:horizontal": {
      width: 4 /* Width of horizontal scrollbar */,
    },
    // zIndex: "10",
  };
  return (
    <>
      {/* demograhic Modal */}

      <Modal
        open={openpatientreg}
        onClose={handleClosepatientreg}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleDetailspatient}>
          <Grid container columnSpacing={1}>
            <Grid item xs={6} style={{ fontWeight: 500 }}>
              <Typography style={{ fontWeight: "bold", color: "black" }}>
                Patient Registration
              </Typography>
            </Grid>
            <Grid item xs={6} style={{ fontWeight: 500 }}>
              <Button
                onClick={handleClosepatientreg}
                style={{
                  marginTop: "0px",
                  marginBottom: "10px",
                  float: "right",
                  marginLeft: "10px",
                  width: "90px",
                  height: "35px",
                  // backgroundColor: '#A574FD',
                  color: "white",
                  fontSize: "14px",
                }}
              >
                <CancelOutlinedIcon
                  fontSize="medium"
                  style={{ color: "red", paddingRight: "5px" }}
                ></CancelOutlinedIcon>
              </Button>
            </Grid>
            <Grid item xs={12} style={{ fontWeight: 500, marginTop: "-90px" }}>
              {/* yaha columnID pass ki patientID ki jga */}

              <PatientRegistration
                callingFrom={"Authorization"}
                pid={colpatientID}
                handleClosepatientreg={handleClosepatientreg}
              ></PatientRegistration>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <Modal
        open={Makepayment}
        onClose={handlecloseMakepayment}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ zIndex: 1760 }}
      >
        <Box sx={modalstyle}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} xl={12}>
              <Headroom>
                <Grid
                  container
                  style={{ backgroundColor: "#356F60", position: "sticky" }}
                >
                  <Grid item xs={12} sm={12} xl={12}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "left",
                        justifyContent: "space-between",
                        height: "2rem",
                      }}
                    >
                      <DialogTitle
                        style={{
                          flex: 1,
                          // textAlign: 'left',
                        }}
                      >
                        <h1
                          style={{
                            fontWeight: "bold",
                            // textAlign: 'left',
                            marginTop: "-10px",
                            color: "#fff",
                            textDecoration: "underline",
                            fontSize: "1rem",
                          }}
                        >
                          Add Make payment
                        </h1>
                      </DialogTitle>
                      <CancelOutlinedIcon
                        onClick={handlecloseMakepayment}
                        fontSize="large"
                        color="red"
                        style={{
                          color: "red",
                          paddingRight: "5px",
                          cursor: "pointer",
                          float: "right",
                          // marginLeft: 'auto',
                          // marginRight: '1.5rem'
                        }}
                      ></CancelOutlinedIcon>
                    </div>
                  </Grid>
                </Grid>
              </Headroom>
            </Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={3} sm={3} xl={3}>
              <Typography style={{ fontSize: "14px", marginTop: "5px" }}>
                Patient Name
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <ClickAwayListener onClickAway={() => setPatient(false)}>
                <TextField
                  {...register("patientName")}
                  size="small"
                  fullWidth
                  autoComplete="off"
                  placeholder="Enter Patient"
                  // value={watch('patientName')} // Using value from form state
                  value={patientId > 0 ? PatientName : watch("patientName")}
                  onKeyUp={(ev) => {
                    console.log("ee:", ev.target.value);
                    setSearchText(ev.target.value);
                    setPatientData([]);
                    if (
                      ev.target.value !== null &&
                      ev.target.value !== "" &&
                      ev.target.value.length > 0
                    ) {
                      onPatientHandle(ev.target.value);
                    } else {
                      setPatient(false);
                    }
                  }}
                  error={!!(errors.patientName || errorsState.patientName)}
                  helperText={
                    errors.patientName?.message || errorsState.patientName
                  }
                />
              </ClickAwayListener>

              {isLoading1 && (
                <CircularProgress size={20} style={{ marginLeft: "-40px" }} />
              )}
              {patient && (
                <div
                  className="col-xs-6"
                  style={{
                    height: 150,
                    overflowY: "scroll",
                    padding: "14px 16px",
                    fontSize: "0.875rem",
                    color: "#67748e",
                    borderRadius: "5px",
                    background: "white",
                    textAlign: "justify",
                    textJustify: "inter-word",
                    position: "absolute",
                    zIndex: "99",
                    width: "39%",
                    border: "1px solid #6cb5f9",
                  }}
                >
                  {patientData.length > 0 ? (
                    patientData.map((s, index) => {
                      var pat = `${patientData[index].lastName}, ${patientData[index].firstName}`;
                      var i = pat.indexOf(searchText);
                      var p1 = pat.substring(0, i);
                      var p = pat.substring(i, i + searchText.length);
                      var p2 = pat.substring(i + searchText.length, pat.length);

                      return (
                        <p
                          style={patientListStyle}
                          onClick={(e) => {
                            setValue(
                              "patientName",
                              `${patientData[index].lastName}, ${patientData[index].firstName}`
                            );
                            setValue("patientId", patientData[index].id);
                            setValue(
                              "patientName",
                              `${patientData[index].lastName}, ${patientData[index].firstName}`
                            );
                            setPatientData([]);
                            setPatient(false);
                            setPatientID(patientData[index].id);
                            setPatientNamee1(
                              `${patientData[index].lastName}, ${patientData[index].firstName}`
                            );
                          }}
                          onBlur={(e) => {
                            setPatientData([]);
                            setPatient(false);
                          }}
                          onChange={(e) => {
                            setPatientData([]);
                            setPatient(false);
                            setPatientNamee1("");
                          }}
                          key={index} // Add key prop to avoid React warning
                        >
                          <span>{p1}</span>
                          <span style={{ backgroundColor: "yellow" }}>{p}</span>
                          <span>{p2}</span>
                        </p>
                      );
                    })
                  ) : (
                    <Typography>No Record found</Typography>
                  )}
                </div>
              )}
            </Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={4} sm={4} xl={4}>
              <Typography style={{ fontSize: "14px", marginTop: "5px" }}>
                Source
              </Typography>
            </Grid>
            {source === "check" ? (
              <>
                <Grid item xs={4} sm={4} xl={4}>
                  <Typography style={{ fontSize: "14px", marginTop: "5px" }}>
                    Check Amount
                  </Typography>
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={4} sm={4} xl={4}>
                  <Typography style={{ fontSize: "14px", marginTop: "5px" }}>
                    Amount
                  </Typography>
                </Grid>
              </>
            )}
            {source === "check" ? (
              <>
                <Grid item xs={3} sm={3} xl={3}>
                  <Typography style={{ fontSize: "14px", marginTop: "5px" }}>
                    Check Date
                  </Typography>
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={3} sm={3} xl={3}>
                  <Typography style={{ fontSize: "14px", marginTop: "5px" }}>
                    Date
                  </Typography>
                </Grid>
              </>
            )}

            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={4} style={{ paddingBottom: "0px" }}>
              <Controller
                name="source"
                margin="dense"
                {...register("source")}
                control={control}
                render={({ field }) => (
                  <>
                  <ReactSelect
                    style={{ marginTop: 0, marginBottom: 0 }}
                    {...field}
                    options={[
                      { value: "cash", label: "Cash" },
                      { value: "check", label: "Check" },
                    ]}
                    value={
                      source
                        ? {
                            value: source,
                            label:
                              source.charAt(0).toUpperCase() + source.slice(1),
                          }
                        : null
                    }
                    onChange={(selectedOption) => {
                      if (selectedOption) {
                        setsource(selectedOption.value);
                      }
                    }}
                    // onChange={value => setValue('source', value.label)}
                    size="small"
                  />
                   {errorsState.source && (
        <p style={{ color: "red", fontSize: 12 }}>{errorsState.source}</p>
      )}
                  </>
                )}
              />
            </Grid>
            <Grid item xs={4} sm={4} xl={4}>
              <Controller
                name="FullName"
                // {...register("userName")}
                control={control}
                render={({ field }) => (
                  <TextField
                    size="small"
                    placeholder="Please enter Amount"
                    {...field}
                    fullWidth
                    value={checkamount}
                    onChange={(ev) => {
                      console.log("ee:", ev.target.value);
                      setcheckamount(ev.target.value);
                    }}
                    error={!!errorsState.checkamount}
                    helperText={errorsState.checkamount}
                  />
                )}
              />
            </Grid>
            <Grid item xs={3} sm={3} xl={3}>
              <Controller
                name="FullName"
                // {...register("userName")}
                control={control}
                render={({ field }) => (
                  <TextField
                    type="date"
                    size="small"
                    {...field}
                    fullWidth
                    value={checkdate}
                    onChange={(ev) => {
                      console.log("ee:", ev.target.value);
                      setcheckdate(ev.target.value);
                    }}
                    error={!!errorsState.checkdate}
                    helperText={errorsState.checkdate}
                  />
                )}
              />
            </Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>

            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={4} sm={4} xl={4}>
              <Typography style={{ fontSize: "14px", marginTop: "5px" }}>
                Claim Dos
              </Typography>
            </Grid>
            <Grid item xs={4} sm={4} xl={4}>
              <Typography style={{ fontSize: "14px", marginTop: "5px" }}>
                CPT
              </Typography>
            </Grid>

            {source === "check" ? (
              <Grid item xs={3} sm={3} xl={3}>
                <Typography style={{ fontSize: "14px", marginTop: "5px" }}>
                  Check No
                </Typography>
              </Grid>
            ) : (
              <>
                {" "}
                <Grid item xs={3} sm={3} xl={3}></Grid>
              </>
            )}
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={4} sm={4} xl={4}>
              <Controller
                name="dos"
                {...register("dos")}
                control={control}
                render={({ field }) => (
                  <>
                  <ReactSelect
                    {...field}
                    fullWidth
                    value={calimdos.find(
                      (option) => option.value === getValues("dos")
                    )}
                    onChange={(value) => {
                      setValue("calimdos", value != null ? value.value : "");
                      setcalimid(value.value);
                      setcalimdosvalue(value.calimdos1);
                    }}
                    options={calimdos}
                  />
                   {errorsState.dos  && (
        <p style={{ color: "red", fontSize: 12 }}>{errorsState.dos }</p>
      )}
                  </>
                )}
              />
            </Grid>
            <Grid item xs={4} sm={4} xl={4}>
              <Controller
                name="cpt1"
                {...register("cpt1")}
                control={control}
                render={({ field }) => (
                  <>
                  <ReactSelect
                    {...field}
                    fullWidth
                    value={calimprocedureCode.find(
                      (option) => option.value == code
                    )}
                    onChange={(e) => {
                      setcode(e.value);
                      setValue("cpt", e.value);
                    }}
                    styles={{
                      control: (provided) => ({ ...provided, width: "99%" }),
                    }}
                    options={calimprocedureCode}
                  />
                   {errorsState.code   && (
        <p style={{ color: "red", fontSize: 12 }}>{errorsState.code  }</p>
      )}
                  </>
                )}
              />
            </Grid>

            {source === "check" ? (
              <Grid item xs={3} sm={3} xl={3}>
                <Controller
                  name="FullName"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      size="small"
                      placeholder="Please enter No"
                      {...field}
                      fullWidth
                      value={checkno}
                      onChange={(ev) => {
                        console.log("Check No:", ev.target.value);
                        setcheckno(ev.target.value);
                      }}
                    />
                  )}
                />
              </Grid>
            ) : (
              <>
                {" "}
                <Grid item xs={3} sm={3} xl={3}></Grid>
              </>
            )}
            {/* <Grid item xs={2} sm={2} xl={2}>
              <Typography style={{ fontSize: '14px', marginTop: '5px' }}>
                Check Amount
              </Typography>
            </Grid>
            <Grid item xs={3} sm={3} xl={3}>
              <Controller
                name="FullName"
                // {...register("userName")}
                control={control}
                render={({ field }) =>
                  <TextField

                    size="small"
                    placeholder="Please enter Amount"
                    {...field}
                    fullWidth
                    value={checkamount}
                    onChange={ev => {
                      console.log('ee:', ev.target.value)
                      setcheckamount(ev.target.value)

                    }
                    }

                  />}
              />

            </Grid> */}
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={11} sm={11} xl={11}>
              <Typography style={{ fontSize: "14px", marginTop: "5px" }}>
                Comments
              </Typography>
            </Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={11} sm={11} xl={11}>
              <TextField
                size="small"
                placeholder="Please enter Comments..."
                fullWidth
                value={comments}
                onChange={(ev) => {
                  console.log("ee:", ev.target.value);
                  setcomments(ev.target.value);
                }}
              />
            </Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>

            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>

            <Grid item xs={11} sm={11} xl={11} style={{ marginTop: "10px" }}>
              <Button
                className="Button"
                onClick={AddGroupmakepayment}
                // disabled={submitting}
                fullWidth
                style={{
                  borderRadius: "10px",
                  color: "white",
                  height: "40px",
                  borderColor: "#EA7772",
                  fontSize: "14px",
                  fontWeight: "bold",
                  float: "right",
                  marginBottom: "10px",
                }}
                type="submit"
              >
                Save
              </Button>
            </Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
          </Grid>
        </Box>
      </Modal>
      <Modal
        open={groupName}
        onClose={handleClosegroupName}
        aria-labelledby="modal-modal-title"
        sx={{ zIndex: 1760 }}
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalstyle}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Headroom>
                <Grid
                  container
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{
                    backgroundColor: "#356F60",
                    padding: "6px 12px",
                  }}
                >
                  <DialogTitle sx={{ padding: 0 }}>
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        color: "#fff",
                        textDecoration: "underline",
                        fontSize: "1rem",
                      }}
                    >
                      Check Add
                    </Typography>
                  </DialogTitle>

                  <CancelOutlinedIcon
                    onClick={handleClosegroupName}
                    sx={{ color: "red", cursor: "pointer" }}
                  />
                </Grid>
              </Headroom>
            </Grid>

            <Grid container sx={{ p: 3 }} spacing={1}>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ fontSize: 14 }}>Check No</Typography>
                <TextField
                  size="small"
                  placeholder="Please enter No"
                  fullWidth
                  value={checkno}
                  error={!!checknoError}
                  helperText={checknoError}
                  onChange={(e) => {
                    setcheckno(e.target.value);
                    setchecknoError("");
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography sx={{ fontSize: 14 }}>Payer</Typography>
                {/* <TextField
                  size="small"
                  placeholder="Please enter Payer"
                  fullWidth
                  value={payer}
                  error={!!payerError}
                  helperText={payerError}
                  onChange={(e) => {
                    setpayer(e.target.value);
                    setPayerError("");
                  }}
                /> */}
                <ReactSelect
                  default
                  size="small"
                  value={Payers.find((option) => option.value == payer)}
     
                  onChange={(value) => {
                    setpayer(value.value);
                    setPayerError("");
                  }}
                  options={Payers}
                />
                {payerError && (
                   <p
                  style={{
                    color: "red",
                    fontSize: "14px",
                    whiteSpace: "nowrap",
                  }}
                >
                    {payerError}
                  </p>
                )}
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography sx={{ fontSize: 14 }}>Check Date</Typography>
                <TextField
                  type="date"
                  size="small"
                  fullWidth
                  value={checkdate}
                  error={!!checkdateError}
                  helperText={checkdateError}
                  onChange={(e) => {
                    setcheckdate(e.target.value);
                    setcheckdateError("");
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography sx={{ fontSize: 14 }}>Check Amount</Typography>
                <TextField
                  size="small"
                  placeholder="Please enter Amount"
                  fullWidth
                  value={checkamount}
                  error={!!checkAmountError}
                  helperText={checkAmountError}
                  onChange={(e) => {
                    setcheckamount(e.target.value);
                    setCheckAmountError("");
                  }}
                />
              </Grid>
              <Grid item xs={9}></Grid>

              <Grid item xs={2} sx={{ m: 2 }}>
                <Button
                  fullWidth
                  onClick={AddGroup}
                  sx={{
                    height: 40,
                    borderRadius: 2,
                    fontWeight: "bold",
                    fontSize: 14,
                    backgroundColor: "#356F60",
                    color: "#fff",
                    "&:hover": {
                      backgroundColor: "#2d5e52",
                    },
                  }}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <Modal
        open={openModalpayment}
        onClose={handleCloseModalpayment}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ zIndex: 1760 }}
      >
        <Box sx={style1}>
          <Headroom>
            <Grid
              container
              style={{ backgroundColor: "#356F60", position: "sticky" }}
            >
              <Grid item xs={3}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    height: "2rem",
                  }}
                >
                  <DialogTitle
                    style={{
                      flex: 1,
                      textAlign: "center",
                    }}
                  >
                    <Typography
                      variant="standard"
                      fontWeight="bold"
                      color="#fff"
                    >
                      {" "}
                      Add Payment
                    </Typography>
                  </DialogTitle>
                </div>
              </Grid>
              <Grid item xs={2.9}>
                <Typography
                  style={{
                    color: "white",
                    marginTop: "8px",
                    float: "right",
                    fontWeight: "bold",
                  }}
                >
                  Patient Name:
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography style={{ color: "white", marginTop: "8px" }}>
                  {PatientNamepayemnt}
                </Typography>
              </Grid>
              <Grid item xs={2.5}>
                <Typography
                  style={{
                    color: "white",
                    marginTop: "8px",
                    float: "right",
                    fontWeight: "bold",
                  }}
                >
                  ID:
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography style={{ color: "white", marginTop: "8px" }}>
                  {columnIDpayment}
                </Typography>
              </Grid>
              <Grid item xs={0.5}>
                <CancelOutlinedIcon
                  onClick={handleCloseModalpayment}
                  fontSize="large"
                  color="red"
                  style={{
                    float: "right",
                    color: "red",
                    paddingRight: "5px",
                    cursor: "pointer",
                    // marginLeft: 'auto',
                    // marginRight: '1.5rem'
                  }}
                ></CancelOutlinedIcon>
              </Grid>
            </Grid>
          </Headroom>
          <Grid
            style={{
              backgroundColor: "#f3f3f4",
              margin: "1.3rem auto",
              border: "1px solid #326C1D",
              borderRadius: "10px",
              width: "98%",
            }}
          >
            <Grid container>
              {paymentDetails != null && paymentDetails.length > 0
                ? paymentDetails.map((row, index) => {
                    return (
                      <Paper
                        variant="outlined"
                        square
                        style={{
                          backgroundColor: "#F0F6F8",
                          borderRadius: "15px",
                          marginTop: "5px",
                          borderColor: "#377562",
                          maxWidth: "100%",
                          padding: ".9rem",
                          marginBottom: "1rem",
                          marginLeft: "0 .2rem",
                        }}
                      >
                        <Grid
                          container
                          spacing={2}
                          item
                          xs={12}
                          sm={12}
                          xl={12}
                        >
                          <Grid item xs={12} sm={6} md={4} lg={3}>
                            <Typography
                              style={{
                                fontSize: "16px",
                                textDecoration: "underline",
                              }}
                            >
                              Procedure code:
                            </Typography>
                            <TextField
                              size="small"
                              value={row.code}
                              style={{ width: "99%" }}
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} sm={6} md={4} lg={3}>
                            <Typography
                              style={{
                                fontSize: "16px",
                                textDecoration: "underline",
                              }}
                            >
                              Diagnosis code:
                            </Typography>
                            {/* <TextField
                            size='small'
                            value={row.dxPointer1}

                            style={{ width: '99%' }}
                            InputProps={{
                              readOnly: true,
                            }}

                          /> */}
                            <Controller
                              name={`dxPointer1_${index}`} // Unique name per row
                              control={control}
                              render={({ field }) => {
                                const selectedCodes =
                                  row.dxPointer1
                                    ?.split(",")
                                    .map((v) => v.trim()) || [];
                                const selectedOptions = selectedCodes.map(
                                  (code) => {
                                    const found = diagnosisList.find(
                                      (option) => String(option.value) === code
                                    );
                                    return (
                                      found || { label: code, value: code }
                                    );
                                  }
                                );

                                return (
                                  <ReactSelect
                                    {...field}
                                    isMulti
                                    // value={diagnosisList.filter(option => row.dxPointer1.includes(option.value))}
                                    value={selectedOptions}
                                    onChange={(selectedOptions) => {
                                      const selectedValues =
                                        selectedOptions.map(
                                          (option) => option.value
                                        );
                                      // Convert to comma-separated string
                                      row.dxPointer1 =
                                        selectedValues.join(", ");
                                    }}
                                    styles={{
                                      control: (provided) => ({
                                        ...provided,
                                        width: "99%",
                                      }),
                                    }}
                                    options={diagnosisList}
                                    isDisabled
                                  />
                                );
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} sm={6} md={4} lg={3}>
                            <Typography
                              style={{
                                fontSize: "16px",
                                textDecoration: "underline",
                              }}
                            >
                              DOS
                            </Typography>

                            <TextField
                              // type='date'
                              size="small"
                              // value={row.dosTo}
                              value={
                                row.dosTo
                                  ? Moment(row.dosTo).format("MM/DD/YYYY")
                                  : ""
                              }
                              style={{ width: "99%" }}
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} sm={6} md={4} lg={3}>
                            <Typography
                              style={{
                                fontSize: "16px",
                                textDecoration: "underline",
                              }}
                            >
                              Charge $
                            </Typography>
                            <TextField
                              size="small"
                              value={row.charges}
                              style={{ width: "99%" }}
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <Typography
                              style={{
                                fontSize: "16px",
                                textDecoration: "underline",
                              }}
                            >
                              Payment Type:
                            </Typography>

                            <Select
                              options={paymentType}
                              placeholder="Payment Type"
                              // value={paymentType.find((option) => option.value === row.paymentType)}
                              value={
                                row.paymentType
                                  ? paymentType.find(
                                      (option) =>
                                        option.value === row.paymentType
                                    )
                                  : null
                              }
                              onChange={(selectedOption) => {
                                let updatedRows = [...paymentDetails];
                                updatedRows[index].paymentType =
                                  selectedOption.value;
                                setPaymentDetails(updatedRows);
                              }}
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <Typography
                              style={{
                                fontSize: "16px",
                                textDecoration: "underline",
                              }}
                            >
                              Payment Sourse:
                            </Typography>
                            <Select
                              options={paymentSourseOption}
                              placeholder="Payment Sourse"
                              value={
                                row.paymentSourse
                                  ? paymentSourseOption.find(
                                      (option) =>
                                        option.value === row.paymentSourse
                                    )
                                  : null
                              }
                              onChange={(selectedOption) => {
                                let updatedRows = [...paymentDetails];
                                updatedRows[index].paymentSourse =
                                  selectedOption.value;
                                setPaymentDetails(updatedRows);
                              }}
                            />
                          </Grid>
                          {row.paymentType == "Check" && (
                            <>
                         <Grid item xs={3}>
  <Typography
    sx={{ fontSize: "16px", textDecoration: "underline", mb: 0.5 }}
  >
    Check Number:
  </Typography>

  <ClickAwayListener
    onClickAway={() => {
      setcheckSearchIndex(null);
      setCheckNoData([]);
    }}
  >
    <div style={{ position: "relative" }}>
      <TextField
        size="small"
        autoComplete="off"
        fullWidth
        placeholder="Search Check Number"
        value={
          checkSearchIndex === index ? searchText : row.checkno || ""
        }
        onChange={(e) => {
          const val = e.target.value;
          setSearchText(val);
          setcheckSearchIndex(index);
          onChangeHandle(val, index);
        }}
        sx={{ backgroundColor: "#fff" }}
        InputProps={{
          endAdornment:
            loadingIndex === index ? (
              <CircularProgress size={18} />
            ) : null,
        }}
      />

      {/* Dropdown */}
    {checkSearchIndex === index && searchText && (
  <div
    style={{
      position: "absolute",
      top: "42px",
      width: "100%",
      maxHeight: 180,
      overflowY: "auto",
      background: "#fff",
      border: "1px solid #c8e0ff",
      borderRadius: 8,
      boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
      zIndex: 1000,
    }}
  >
    {loadingIndex === index ? (
      <div
        style={{
          padding: "12px",
          textAlign: "center",
          color: "#67748e",
          fontSize: 14,
        }}
      >
        Searching…
      </div>
    ) : checkNoData.length > 0 ? (
      checkNoData.map((item) => (
        <div
          key={item.id}
          style={{
            padding: "10px 14px",
            cursor: "pointer",
            borderBottom: "1px solid #eee",
            fontWeight: 500,
            color: "#344767",
          }}
          onClick={() => {
            const rows = [...paymentDetails];

            rows[index] = {
              ...rows[index],
              eRAId: item.id,
              checkno: item.checkno,
              payer: item.payer,
              checkdate: item.checkdate,
              checkamount: item.checkamount,
            };

            setPaymentDetails(rows);
            setSearchText(item.checkno);
            setcheckSearchIndex(null);
            setCheckNoData([]);
          }}
        >
          {highlightMatch(item.checkno, searchText)}
        </div>
      ))
    ) : (
      /* ✅ NO MATCH MESSAGE */
      <div
        style={{
          padding: "14px",
          textAlign: "center",
          color: "#d32f2f",
          fontWeight: 600,
          fontSize: 14,
        }}
      >
        No matching check found
      </div>
    )}
  </div>
)}

    </div>
  </ClickAwayListener>
</Grid>


                              {/* ADD NEW CHECK – Beautiful Chip Button */}
                              <Grid item xs={3}>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    marginTop: "20px",
                                  }}
                                >
                                  <Chip
                                    clickable
                                    onClick={handleOpengroupName}
                                    icon={
                                      <AddCircleOutlineRoundedIcon
                                        style={{
                                          color: "#0d6efd",
                                          fontSize: "20px",
                                          marginLeft: "4px",
                                        }}
                                      />
                                    }
                                    label="Add New Check"
                                    style={{
                                      borderColor: "#0d6efd",
                                      color: "#0d6efd",
                                      fontWeight: 600,
                                      padding: "6px 10px",
                                      borderRadius: "12px",
                                      fontSize: "13px",
                                      background:
                                        "linear-gradient(145deg, rgba(255,255,255,0.95), rgba(245,247,255,0.9))",
                                      boxShadow: "0 3px 8px rgba(0,0,0,0.12)",
                                      transition: "0.2s ease-in-out",
                                      cursor: "pointer",
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.boxShadow =
                                        "0 4px 14px rgba(0,0,0,0.18)";
                                      e.currentTarget.style.background =
                                        "linear-gradient(145deg, #e9f1ff, #ffffff)";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.boxShadow =
                                        "0 3px 8px rgba(0,0,0,0.12)";
                                      e.currentTarget.style.background =
                                        "linear-gradient(145deg, rgba(255,255,255,0.95), rgba(245,247,255,0.9))";
                                    }}
                                  />

                                  <Typography
                                    variant="caption"
                                    style={{
                                      marginTop: "6px",
                                      fontSize: "11px",
                                      color: "#5f6c7b",
                                      opacity: 0.8,
                                    }}
                                  >
                                    If check is not found, click to add
                                  </Typography>
                                </div>
                              </Grid>
                            </>
                          )}
                          {row.paymentType == "Check" && (
                            <Grid item xs={3}>
                              <Typography
                                style={{
                                  fontSize: "16px",
                                  textDecoration: "underline",
                                }}
                              >
                                Payer:
                              </Typography>

                              <Controller
                                name="payer"
                                {...register("payer")}
                                control={control}
                                render={({ field }) => (
                                  <TextField
                                    size="small"
                                    placeholder="Payer..."
                                    fullWidth
                                    value={row.payer}
                                    InputProps={{
                                      readOnly: true,
                                    }}
                                  />
                                )}
                              />
                            </Grid>
                          )}
                          {row.paymentType == "Check" ? (
                            <>
                              <Grid item xs={3}>
                                <Typography
                                  style={{
                                    fontSize: "16px",
                                    textDecoration: "underline",
                                  }}
                                >
                                  Check Date:
                                </Typography>
                                <TextField
                                  // type='date'
                                  size="small"
                                  value={row.checkdate}
                                  style={{ width: "99%" }}
                                  InputProps={{
                                    readOnly: true,
                                  }}
                                />
                              </Grid>
                              <Grid item xs={3}>
                                <Typography
                                  style={{
                                    fontSize: "16px",
                                    textDecoration: "underline",
                                  }}
                                >
                                  Check Amount:
                                </Typography>

                                <Controller
                                  name="checkamount"
                                  {...register("checkamount")}
                                  control={control}
                                  render={({ field }) => (
                                    <TextField
                                      type="test"
                                      size="small"
                                      placeholder="Check amount..."
                                      {...field}
                                      fullWidth
                                      value={row.checkamount}
                                      InputProps={{
                                        readOnly: true,
                                      }}
                                    />
                                  )}
                                />
                              </Grid>
                              <Grid item xs={3}></Grid>
                            </>
                          ) : (
                            // <Grid item xs={3}></Grid>
                            ""
                          )}
                          <Grid item xs={12} sm={6} md={4} lg={3}>
                            <Typography
                              style={{
                                fontSize: "16px",
                                textDecoration: "underline",
                              }}
                            >
                              Allowed Amount
                            </Typography>

                            <TextField
                              size="small"
                              placeholder="Enter Allowed Amount"
                              fullWidth
                              value={row.allowamount}
                              sx={{
                                backgroundColor: "#fff",
                              }}
                              onChange={(ev) => {
                                console.log("ee:", ev.target.value);
                                var _row = paymentDetails;
                                _row[index].allowamount = ev.target.value;

                                setPaymentDetails([..._row]);
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4} lg={3}>
                            <Typography
                              style={{
                                fontSize: "16px",
                                textDecoration: "underline",
                              }}
                            >
                              Paid Amount
                            </Typography>

                            <Controller
                              name="paidmount"
                              // {...register("userName")}
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  size="small"
                                  placeholder="Enter Paid Amount"
                                  {...field}
                                  fullWidth
                                  sx={{
                                    backgroundColor: "#fff",
                                  }}
                                  value={row.paidamount}
                                  onChange={(ev) => {
                                    console.log("ee:", ev.target.value);
                                    var _row = paymentDetails;
                                    // _row[index].paidamount = ev.target.value;
                                      _row[index].paidamount = Number(ev.target.value || 0);
                                        _row[index].balance =
                                        Number(_row[index].charges || 0) -
                                        Number(_row[index].writeoff || 0) -
                                        Number(_row[index].adjustmentamount || 0) -
                                        Number(_row[index].paidamount || 0);
                                    // _row[index].balance =
                                    //   row.charges -
                                    //   (row.writeoff || 0) -
                                    //   (row.adjustmentamount || 0) -
                                    //   (row.paidamount || 0);
                                    // setpaidpayemnt(ev.target.value)
                                    setPaymentDetails([..._row]);
                                  }}
                                />
                              )}
                            />
                            {/* {errorArray[index] && (
                            <Typography style={{ color: 'red', marginLeft: 15 }}>
                              Please fill the Paid Amount
                            </Typography>
                          )} */}
                          </Grid>
                          <Grid item xs={12} sm={6} md={4} lg={3}>
                            <Typography
                              style={{
                                fontSize: "16px",
                                textDecoration: "underline",
                              }}
                            >
                              Adjustment Amount
                            </Typography>

                            <Controller
                              name="FullName"
                              // {...register("userName")}
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  size="small"
                                  placeholder="Enter Adjustment Amount"
                                  {...field}
                                  fullWidth
                                  sx={{
                                    backgroundColor: "#fff",
                                  }}
                                  value={row.adjustmentamount}
                                  onChange={(ev) => {
                                    console.log("ee:", ev.target.value);
                                    var _row = paymentDetails;
                                    // _row[index].adjustmentamount =
                                    //   ev.target.value;
                                    // setadjustmentpayemnt(ev.target.value)
                                       _row[index].adjustmentamount = Number(ev.target.value || 0);
                                        _row[index].balance =
                                        Number(_row[index].charges || 0) -
                                        Number(_row[index].writeoff || 0) -
                                        Number(_row[index].adjustmentamount || 0) -
                                        Number(_row[index].paidamount || 0);
                                    // _row[index].balance =
                                    //   row.charges -
                                    //   (row.writeoff || 0) -
                                    //   (row.adjustmentamount || 0) -
                                    //   (row.paidamount || 0);

                                    setPaymentDetails([..._row]);
                                  }}
                                />
                              )}
                            />
                          </Grid>

                          <Grid item xs={12} sm={6} md={4} lg={3}>
                            <Typography
                              style={{
                                fontSize: "16px",
                                textDecoration: "underline",
                              }}
                            >
                              Write Off
                            </Typography>

                            <Controller
                              name="FullName"
                              // {...register("userName")}
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  size="small"
                                  placeholder="Enter Write off Amount Here"
                                  {...field}
                                  fullWidth
                                  sx={{
                                    backgroundColor: "#fff",
                                  }}
                                  value={row.writeoff}
                                  onChange={(ev) => {
                                    var _row = paymentDetails;
                                    // _row[index].writeoff = ev.target.value;
                                    // _row[index].balance =
                                    //   row.charges -
                                    //   (row.writeoff || 0) -
                                    //   (row.adjustmentamount || 0) -
                                    //   (row.paidamount || 0);
                                        _row[index].writeoff = Number(ev.target.value || 0);
                                        _row[index].balance =
                                        Number(_row[index].charges || 0) -
                                        Number(_row[index].writeoff || 0) -
                                        Number(_row[index].adjustmentamount || 0) -
                                        Number(_row[index].paidamount || 0);
                                    console.log("ee:", _row);
                                    setPaymentDetails([..._row]);
                                  }}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={9}>
                            <Typography
                              style={{
                                fontSize: "16px",
                                textDecoration: "underline",
                              }}
                            >
                              WriteOff Reason
                            </Typography>

                            <TextField
                              size="small"
                              fullWidth
                              value={row.writeOffReason}
                              sx={{
                                backgroundColor: "#fff",
                              }}
                              onChange={(ev) => {
                                const updatedDetails = [...paymentDetails];
                                updatedDetails[index].WriteOffReason =
                                  ev.target.value;
                                setPaymentDetails(updatedDetails);
                              }}
                            />
                          </Grid>
                          <Grid item xs={2}>
                            <Typography
                              style={{
                                fontSize: "16px",
                                textDecoration: "underline",
                              }}
                            >
                              Balance
                            </Typography>
                            <TextField
                              size="small"
                              fullWidth
                              value={row.balance}
                              onChange={(ev) => {
                                console.log("ee:", ev.target.value);
                                var _row = paymentDetails;
                                setPaymentDetails([..._row]);
                              }}
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Paper>
                    );
                  })
                : "No Record Found"}
              <Grid item xs={6} lg={6} sm={6}></Grid>

              <Grid item xs={3} lg={3} sm={3}>
                {rights.Claim_payment_CloseClaim_Button &&
                  CompletdClaims == true && (
                    <Button
                      className="Button"
                      variant="gradient"
                      onClick={handleSubmit(onSubmitClaimComplete)}
                      style={{
                        marginTop: "15px",
                        marginBottom: "10px",
                        width: "227px",
                        height: "35px",
                        color: "white",
                        fontSize: "12px",
                      }}
                    >
                      <CloseOutlined
                        fontSize="medium"
                        style={{
                          color: "white",
                          paddingRight: "5px",
                          paddingBottom: "2px",
                        }}
                      ></CloseOutlined>
                      Close Claim/Completed
                    </Button>
                  )}
              </Grid>
              <Grid item xs={3} lg={3} sm={3}>
                <Button
                  className="Button"
                  onClick={handleSubmit(saveData)}
                  variant="gradient"
                  style={{
                    marginTop: "15px",
                    marginBottom: "10px",
                    // width: "200px",
                    height: "35px",
                    color: "white",
                    fontSize: "12px",
                  }}
                >
                  <SaveOutlinedIcon
                    fontSize="medium"
                    style={{
                      color: "white",
                      paddingRight: "5px",
                      paddingBottom: "2px",
                    }}
                  ></SaveOutlinedIcon>
                  Save/Add Additional Payment later
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      {openModal ? (
        <>
          <>
            <Grid
              container
              xs={12}
              spacing={1}
              style={{
                marginTop: "50px",
                marginBottom: "10px",
                // borderRadius: '20px',
                // border: '1px solid rgba(5, 152, 236, 0.637)',
                // overflow:'scroll'
              }}
            >
              <Grid container>
                <Grid item xs={0.3}></Grid>

                <Grid item xs={11.2}>
                  {patientId > 0 ? (
                    <></>
                  ) : (
                    <>
                      <Typography
                        variant="h5"
                        fontWeight="bold"
                        style={{ marginTop: "2rem" }}
                      >
                        Claim Submission Request
                      </Typography>
                    </>
                  )}
                </Grid>
                <Grid item xs={0.5}></Grid>
              </Grid>

              <Grid
                container
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{
                  width: "100%",
                  marginTop: "1px",
                  borderRadius: "20px",
                  height: "100%",
                  padding: "5px",
                }}
                bgcolor={"#356F60"}
              >
                <Grid item xs={1.5}>
                  <Button
                    className="Button"
                    onClick={handleCloseModal}
                    variant="contained"
                    color="info"
                    size="small"
                    style={{
                      width: "20px",
                      float: "left",
                      marginLeft: "15px",
                      //  marginRight: '10px',
                      height: "30px",
                      marginTop: "8px",
                      //  backgroundColor:'#E87426'
                    }}
                  >
                    <ArrowBackIosIcon
                      fontSize="medium"
                      style={{
                        color: "#1a82ad",
                        //  padding: "5px",
                        //  marginLeft: '5px'
                      }}
                    ></ArrowBackIosIcon>
                    Back
                  </Button>
                </Grid>
                <Grid item xs={5}>
                  <Box display="flex" alignItems="center" mt={1} gap={4}>
                    <Typography style={{ fontWeight: "bold", color: "#fff" }}>
                      Patient Name:{" "}
                      <span style={{ fontWeight: "normal" }}>
                        {patientName}
                      </span>
                    </Typography>
                    <Typography style={{ fontWeight: "bold", color: "#fff" }}>
                      Patient Id:{" "}
                      <span style={{ fontWeight: "normal" }}>
                        {colpatientID}
                      </span>
                    </Typography>
                  </Box>
                </Grid>
                {patientId > 0 ? (
                  ""
                ) : (
                  <Grid item xs={2.5}>
                    <Button
                      className="Button"
                      variant="contained"
                      color="info"
                      fullWidth
                      disabled={columnID <= 0}
                      style={{
                        float: "left",
                        height: "30px",
                        marginTop: "8px",
                      }}
                      size="small"
                      onClick={handleOpenpatientreg}
                    >
                      Go to patient Chart
                    </Button>
                  </Grid>
                )}
                <Grid item xs={2}>
                  <Typography
                    style={{
                      color: "white",
                      marginTop: "8px",
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                  >
                    ID: <span style={{ fontWeight: "normal" }}>{columnID}</span>
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <ClaimRegistration
                  Namee={Namee}
                  claimPracticeID={claimPracticeID}
                  claimId={columnID}
                  patientName={patientName}
                  claimpatientId={colpatientID}
                  patientId={patientId}
                  CloseModal={handleCloseModal}
                  applyRefresh={applyRefresh}
                ></ClaimRegistration>
              </Grid>
            </Grid>
          </>
        </>
      ) : (
        <>
          {patientId > 0 ? (
            <>
              <div>
                <Grid container spacing={1}>
                  <Grid item xs={1}>
                    <Checkbox
                      checked={isChecked}
                      style={{ marginTop: "20px" }}
                      onClick={handleClick}
                    />
                    <Typography
                      style={{ marginTop: "-33px", marginLeft: "40px" }}
                    >
                      All
                    </Typography>
                  </Grid>

                  <Grid item xs={2}>
                    <Typography> From Date </Typography>
                    <Controller
                      name="fromDate"
                      // {...register('fromDate')}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          // isClearable
                          size="small"
                          type="date"
                          disabled={isChecked == true ? true : false}
                          {...field}
                          fullWidth
                          value={fromDate}
                          // error={errors.fromDate}
                          onChange={(e) => {
                            setValue("fromDate", e.target.value);
                            setfromDate(e.target.value);
                          }}
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={2}>
                    <Typography> Date To </Typography>
                    <Controller
                      name="toDate"
                      // {...register('toDate')}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          // isClearable
                          size="small"
                          type="date"
                          disabled={isChecked == true ? true : false}
                          {...field}
                          fullWidth
                          value={toDate}
                          // error={errors.fromDate}
                          onChange={(e) => {
                            setValue("toDate", e.target.value);
                            settoDate(e.target.value);
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={2.5}>
                    <Typography style={{ color: "black", fontSize: "18px" }}>
                      Status:
                    </Typography>
                    <ReactSelect
                      fullWidth
                       isMulti
                      options={statusOptions}
  value={statusOptions.filter(option =>
    ClaimStatus.includes(option.value)
  )}
                      onChange={handleStatusChange}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <Button
                      className="Button"
                      fullWidth
                      variant="contained"
                      onClick={onFilterSearch}
                      style={{
                        float: "right",
                        // width: '125px',
                        height: "35px",
                        marginTop: "25px",

                        fontSize: "14px",
                        color: "white",
                        // backgroundColor:'#004cab'
                      }}
                    >
                      <SearchOutlinedIcon
                        fontSize="medium"
                        style={{ color: "white", paddingBottom: "1px" }}
                      ></SearchOutlinedIcon>
                      Search
                    </Button>
                  </Grid>
                  <Grid item xs={2}>
                    <Button
                      className="Button"
                      variant="contained"
                      fullWidth
                      onClick={handleOpen1}
                      style={{
                        float: "right",
                        // width: '125px',
                        height: "35px",
                        marginTop: "25px",
                        marginLeft: "50px",
                        fontSize: "14px",
                        color: "white",
                        // backgroundColor:'#004cab'
                      }}
                    >
                      <AddOutlinedIcon
                        fontSize="medium"
                        style={{ color: "white", paddingBottom: "1px" }}
                      ></AddOutlinedIcon>
                      Add new
                    </Button>
                  </Grid>
                  <Grid item xs={3.7}></Grid>

                  <Grid item xs={4}>
                    <Button
                      className="Button"
                      variant="contained"
                      onClick={handleopenMakepayment}
                      style={{
                        float: "right",
                        // width: "300px",
                        height: "35px",
                        marginTop: "5px",
                        fontSize: "12px",
                        color: "white",
                      }}
                    >
                      <AddOutlinedIcon
                        fontSize="medium"
                        style={{ color: "white", paddingBottom: "1px" }}
                      ></AddOutlinedIcon>
                      Make Patient Payment to full balance
                    </Button>
                  </Grid>
                  <Grid item xs={2.3}>
                    <Button
                      className="Button"
                      variant="contained"
                      onClick={handleGenerateSuperBill}
                      style={{
                        height: "35px",
                        marginTop: "5px",
                        fontSize: "14px",
                        color: "white",
                      }}
                    >
                      Generate Super Bill
                    </Button>
                  </Grid>
                  <Grid item xs={2}>
                    <Button
                      className="Button"
                      variant="contained"
                      onClick={handleGenerateClaims}
                      style={{
                        height: "35px",
                        marginTop: "5px",
                        fontSize: "14px",
                        color: "white",
                      }}
                    >
                      Generate Claims
                    </Button>
                  </Grid>
                </Grid>
                {/* <div style={{ width: 200, marginTop: '5px', marginBottom: '0px' }}>

                  <Button sx={{ mb: 1 }} className="Button" onClick={openClaimRegistration} variant='contained'>
                  <AddOutlinedIcon
                  fontSize='small'
                  style={{
                    color: 'white',
                    paddingRight: '4px',
                    paddingBottom: '2px'
                  }}
                ></AddOutlinedIcon>
                    Add New
                  </Button>
                </div> */}

                <Box mb={3} marginTop={2}>
                  {isLoading ? (
                    <div style={{ margin: "5rem", textAlign: "center" }}>
                      <CircularProgress />
                    </div>
                  ) : (
                    <div
                      style={{ height: 400, width: "100%", overflowX: "auto" }}
                    >
                      {rows === null || rows.length === 0 ? (
                        <Typography>No Record found</Typography>
                      ) : (
                        <DataGrid
                          rows={rows}
                          classes={gridClasses}
                          columns={columns}
                          // getRowSpacing={getRowSpacing}
                          //checkboxSelection
                          pagination
                          pageSizeOptions={[25]}
                          sx={gridRowStyle}
                          rowHeight={30}
                          initialState={{
                            pagination: {
                              paginationModel: { pageSize: 100, page: 0 },
                            },
                          }}
                        />
                      )}
                    </div>
                  )}
                </Box>
              </div>
            </>
          ) : (
            <>
              <div className="page-content">
                <Grid container spacing={1}>
                  <Grid item xs={1}>
                    <Checkbox
                      checked={isChecked}
                      style={{ marginTop: "20px" }}
                      onClick={handleClick}
                    />
                    <Typography
                      style={{ marginTop: "-33px", marginLeft: "40px" }}
                    >
                      All
                    </Typography>
                  </Grid>
                  {rights.All_Practices_Claims && (
                    <Grid item xs={1.8}>
                      <Checkbox
                        value={isAllPractics}
                        style={{ marginTop: "20px" }}
                        onChange={(e) => {
                          setisAllPractics(e.target.checked);
                        }}
                      />
                      <Typography
                        style={{ marginTop: "-33px", marginLeft: "40px" }}
                      >
                        All Practices
                      </Typography>
                    </Grid>
                  )}

                  <Grid item xs={1.8}>
                    <Typography> From Date </Typography>
                    <Controller
                      name="fromDate"
                      // {...register('fromDate')}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          // isClearable
                          size="small"
                          type="date"
                          disabled={isChecked == true ? true : false}
                          {...field}
                          fullWidth
                          value={fromDate}
                          // error={errors.fromDate}
                          onChange={(e) => {
                            setValue("fromDate", e.target.value);
                            setfromDate(e.target.value);
                          }}
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={1.8}>
                    <Typography>To Date </Typography>
                    <Controller
                      name="toDate"
                      // {...register('toDate')}
                      control={control}
                      render={({ field }) => (
                        <TextField
                          // isClearable
                          size="small"
                          type="date"
                          disabled={isChecked == true ? true : false}
                          {...field}
                          fullWidth
                          value={toDate}
                          // error={errors.fromDate}
                          onChange={(e) => {
                            setValue("toDate", e.target.value);
                            settoDate(e.target.value);
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={2.6}>
                    <Typography style={{ color: "black", fontSize: "18px" }}>
                      Status:
                    </Typography>
                    <ReactSelect
                      fullWidth
                       isMulti
                      options={statusOptions}
                       value={statusOptions.filter(option =>
    ClaimStatus.includes(option.value)
  )}
                      onChange={handleStatusChange}
                    />
                  </Grid>
                  <Grid item xs={1.5}>
                    <Button
                      className="Button"
                      variant="contained"
                      fullWidth
                      onClick={onFilterSearch}
                      style={{
                        float: "right",
                        height: "35px",
                        marginTop: "25px",
                        fontSize: "14px",
                        color: "white",
                        // backgroundColor:'#004cab'
                      }}
                    >
                      <SearchOutlinedIcon
                        fontSize="medium"
                        style={{ color: "white", paddingBottom: "1px" }}
                      ></SearchOutlinedIcon>
                      Search
                    </Button>
                  </Grid>
                  <Grid item xs={1.5}>
                    {rights.Add_Claim && (
                      <Button
                        className="Button"
                        variant="contained"
                        fullWidth
                        onClick={handleOpen1}
                        style={{
                          float: "right",
                          height: "35px",
                          marginTop: "25px",
                          marginLeft: "50px",
                          fontSize: "14px",
                          color: "white",
                          // backgroundColor:'#004cab'
                        }}
                      >
                        <AddOutlinedIcon
                          fontSize="medium"
                          style={{ color: "white", paddingBottom: "1px" }}
                        ></AddOutlinedIcon>
                        Add new
                      </Button>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={3.7} md={3.7} lg={3.7}></Grid>

                  <Grid item xs={4}>
                    {rights.Make_Patient_Payment && (
                      <Button
                        className="Button"
                        variant="contained"
                        onClick={handleopenMakepayment}
                        style={{
                          float: "right",
                          // width: "300px",
                          height: "35px",
                          marginTop: "5px",
                          fontSize: "12px",
                          color: "white",
                        }}
                      >
                        <AddOutlinedIcon
                          fontSize="medium"
                          style={{ color: "white", paddingBottom: "1px" }}
                        ></AddOutlinedIcon>
                        Make Patient Payment to full balance
                      </Button>
                    )}
                  </Grid>
                  <Grid item xs={2.3}>
                    <Button
                      className="Button"
                      variant="contained"
                      onClick={handleGenerateSuperBill}
                      style={{
                        height: "35px",
                        marginTop: "5px",
                        fontSize: "14px",
                        color: "white",
                      }}
                    >
                      Generate Super Bill
                    </Button>
                  </Grid>
                  <Grid item xs={2}>
                    <Button
                      className="Button"
                      variant="contained"
                      onClick={handleGenerateClaims}
                      style={{
                        height: "35px",
                        marginTop: "5px",
                        fontSize: "14px",
                        color: "white",
                      }}
                    >
                      Generate Claims
                    </Button>
                  </Grid>
                </Grid>
                {/* <div style={{ width: 200, marginTop: '5px', marginBottom: '0px' }}>

                  <Button sx={{ mb: 1 }} className="Button" onClick={openClaimRegistration} variant='contained'>
                  <AddOutlinedIcon
                  fontSize='small'
                  style={{
                    color: 'white',
                    paddingRight: '4px',
                    paddingBottom: '2px'
                  }}
                ></AddOutlinedIcon>
                    Add New
                  </Button>
                </div> */}

                <Box mb={3} marginTop={2}>
                  {isLoading ? (
                    <div style={{ margin: "5rem", textAlign: "center" }}>
                      <CircularProgress />
                    </div>
                  ) : (
                    <div
                      style={{ height: 400, width: "100%", overflowX: "auto" }}
                    >
                      {rows === null || rows.length === 0 ? (
                        <Typography>No Record found</Typography>
                      ) : (
                        <DataGrid
                          rows={rows}
                          classes={gridClasses}
                          // rowHeight={20}
                          columns={columns}
                          // getRowSpacing={getRowSpacing}/
                          //checkboxSelection
                          pagination
                          pageSizeOptions={[25]}
                          sx={gridRowStyle}
                          rowHeight={30}
                          initialState={{
                            pagination: {
                              paginationModel: { pageSize: 100, page: 0 },
                            },
                          }}
                        />
                      )}
                    </div>
                  )}
                </Box>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default Claim;
